// Imports for external libraries go here.
import React, { FC } from 'react';
import clsx from 'clsx';
import DOMPurify from 'isomorphic-dompurify';
import { RichText } from '@marriott/mi-ui-library';

import { LegalTextWithLinkProps } from './LegalTextWithLink.types';
import { StyledLegalTextWithLink } from './LegalTextWithLink.styles';

export const LegalTextWithLink: FC<LegalTextWithLinkProps> = ({
  descriptionText,
  className,
  innerChildClassName,
  testId,
}) => {
  const textToRender = DOMPurify.sanitize(descriptionText, {
    RETURN_DOM: true,
    ALLOWED_ATTR: ['href', 'target', 'class', 'id', 'style'],
    ALLOWED_TAGS: [
      'a',
      'span',
      'ul',
      'li',
      'u',
      'h1',
      'h2',
      'h3',
      'h4',
      'h5',
      'h6',
      'strong',
      'b',
      'p',
      'hr',
      'br',
      'div',
      'i',
    ],
  }) as HTMLElement;

  const fragmentString = textToRender.innerHTML;

  return (
    <StyledLegalTextWithLink
      data-component-name="m-legal-LegalTextWithLink"
      data-testid={testId ?? 'legal-LegalTextWithLink'}
      className={className}
    >
      {descriptionText && (
        <RichText
          componentId={'descriptionText'}
          text={fragmentString}
          customClass={clsx('legal-text-link', innerChildClassName)}
        />
      )}
    </StyledLegalTextWithLink>
  );
};
